import React, { FunctionComponent } from 'react'

import { TextType, TitleSize } from '../../styles/typeStyles'
import { BaseText, BaseTextProps } from '../baseText/BaseText'

export interface TitleProps extends Omit<BaseTextProps, 'size' | 'type'> {
  size: TitleSize
}

// Map title sizes to header levels for web accessibility (h1, h2, etc)
const defaultLevels: Partial<Record<TitleSize, string>> = {
  [TitleSize.LARGE]: '2',
  [TitleSize.MEDIUM]: '3',
  [TitleSize.SMALL]: '4',
  [TitleSize.XSMALL]: '4',
}

export const Title: FunctionComponent<TitleProps> = (props) => {
  const { size, level } = props
  return <BaseText {...props} type={TextType.TITLE} level={level === undefined ? defaultLevels[size] : level} />
}
export const Size = TitleSize
